import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Http, Response, Headers } from '@angular/http';
import { environment } from '../../environments/environment';


@Injectable()
export class UserService {

  constructor(private http: Http) { }

  private apiUrl: String = environment.apiUrl;
  private headers = new Headers({ 'Content-Type': 'application/json' });
  public userCurrency = null;

  getUserDetails(): Observable<any> {
    return this.http
        .get(`${this.apiUrl}/user`, { headers: this.headers })
        .map(response => {
          return response.json();
        });
  }

  updateUserDetails(user): Observable<any> {
      return this.http
        .put(`${this.apiUrl}/user/` + user.id, { 'user': user})
        .map(response => {
          this.updateUserCurrency(user.currency);
          return response.json();
        });
  }

  deleteUser(user): Observable<any> {

    return this.http
      .delete(`${this.apiUrl}/user/` + user.id)
      .map(response => {
        return true;
      });
}


  getUserCurrency() {

    if (this.userCurrency === null) {
      this.getUserDetails().subscribe(response => {
        const currencyInDB = response['currency'];
        this.updateUserCurrency(currencyInDB);
      });
    }
    return this.userCurrency;
  }


  getUserOnboardingStatus() {
    return this.http
    .get(`${this.apiUrl}/onboarding-status`, { headers: this.headers })
    .map(response => {
      return response.json();
    });
  }


  updateUserCurrency(currencyInDB) {
    if (currencyInDB === 'euro') {
      this.userCurrency = '€';
    }else if (currencyInDB === 'pound') {
      this.userCurrency = '£';
    }else {
      this.userCurrency = '$';
    }
  }
}




// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/mmam/angular/src/app/app-services/user.service.ts